import { PencilRuler, Smartphone, Loader2 } from 'lucide-react';

/**
 * Friendly empty state shown in the floor-plan viewer area when a room has
 * never been scanned. Replaces the jarring "Unable to Load Floor Plan" error
 * card for the common no-scan case, guiding the user to either draw a plan by
 * hand or capture one with the iPhone app.
 *
 * @param {Object} props
 * @param {Function} props.onCreatePlan - Start a blank by-hand plan (opens the editor)
 * @param {boolean} props.busy - A create request is in flight
 */
const FloorPlanEmptyState = ({ onCreatePlan, busy = false }) => {
    return (
        <div className="flex flex-col h-full bg-[var(--bg-elevated)] rounded-xl overflow-hidden shadow-[var(--shadow-sm)]">
            <div className="flex-1 flex items-center justify-center p-8">
                <div className="text-center max-w-sm">
                    <div className="w-14 h-14 mx-auto mb-4 rounded-full bg-[var(--primary-container)] flex items-center justify-center">
                        <PencilRuler className="w-7 h-7 text-[var(--primary-container-text)]" />
                    </div>
                    <h3 className="text-lg font-semibold text-[var(--text-main)] mb-2">
                        No floor plan yet
                    </h3>
                    <p className="text-sm text-[var(--text-secondary)] mb-5">
                        Create one by hand, or scan this room with the Hestia app on your
                        iPhone to capture it automatically.
                    </p>
                    <button
                        onClick={onCreatePlan}
                        disabled={busy}
                        className="inline-flex items-center gap-2 px-4 py-2 bg-[var(--primary)] text-[var(--primary-text)] text-sm font-medium rounded-lg hover:opacity-90 transition disabled:opacity-50"
                    >
                        {busy ? <Loader2 size={16} className="animate-spin" /> : <PencilRuler size={16} />}
                        Create Floor Plan
                    </button>
                    <div className="mt-5 flex items-center justify-center gap-2 text-xs text-[var(--text-muted)]">
                        <Smartphone size={14} className="shrink-0" />
                        <span>iPhone scanning: open the Hestia app and scan this room.</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FloorPlanEmptyState;
